import { defaultIconProps, IconProps } from './IconProps';

export const IconCheckThin: import('react').FC<IconProps> = ({ size, color = '#195AFF', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

IconCheckThin.defaultProps = defaultIconProps;
